"use strict";
exports.__esModule = true;
exports.isObject = void 0;
function isObject(o) {
    return typeof o === 'object' && Object.prototype.toString.call(o) === '[object Object]';
}
exports.isObject = isObject;
//# sourceMappingURL=is-object.js.map